// @flow
import type { FullState } from '../../../types';
import type { Search, AlteredSearch } from '../../types';

const selectRaw = (state: FullState): Search => state.domainSuggest.search;
export const selectSearchValue = (state: FullState): string =>
  selectRaw(state).value;
export const selectSearchLoading = (state: FullState): boolean =>
  selectRaw(state).loading;
export const selectSearchFirstResultLoading = (state: FullState): boolean =>
  selectRaw(state).firstResultLoading;
export const selectSearchError = (state: FullState): boolean =>
  selectRaw(state).error;
export const selectFilterFailed = (state: FullState): boolean =>
  selectRaw(state).filterFailed;
export const selectAlteredSearch = (state: FullState): false | AlteredSearch =>
  selectRaw(state).alteredSearch;
export const selectRequiredAvailables = (state: FullState): number =>
  selectRaw(state).requiredAvailables;
export const selectSearchUUID = (state: FullState): void | string =>
  selectRaw(state).searchUUID;
